export default "__VITE_ASSET__BjU0ispO__"